// @flow

import * as React from 'react';
import styles from './Placeholder.css';

type Props = {
  editable: boolean,
  onClickAddOrderCaveat: () => void
}

class Component extends React.PureComponent<Props> {

  render () {

    const {
      editable,
      onClickAddOrderCaveat
    } = this.props;

    return (

      <div
        className={styles.wrapper}
      >

        <div className={styles.message}>

          {'There are no caveats on this order. '}

          {editable && (
            <span>
              <span
                className={styles.addLink}
                onClick={onClickAddOrderCaveat}
                role="presentation"
              >
                {'Add Caveat'}
              </span>
              {' to get started.'}
            </span>
          )}

        </div>

      </div>

    )
  }
}

export default Component;